import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SettingService {

    constructor(private httpService: HttpService) { }


    customerblockDelete(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/customerblock/${data}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    // Citys APi
    saveBlock(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/customerblock`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    deletePartner(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/partner/${data}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    editPartner(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/edit-partner`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    savePartner(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/partner`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getPartenerForTable(data: any) {
        const url = `${environment.SettingsApiendpoint}/partners?${data}`;

        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getCustomerBlockForTable(data: any) {
        const url = `${environment.SettingsApiendpoint}/customerblock?${data}`;

        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
//// ====================city all api start------------===================

    getCitysForTable(data: any) {
        const url = `${environment.SettingsApiendpoint}/cities?${data}`;

        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    createCity(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/cities`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateCity(data: any, id: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/cities/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    deleteCity(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/cities/${data}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

//// ====================----city all api-end------------===================


//// ====================----areacode all api-start------------===================
    getAreaCodesForTable(data: any) {
        const url = `${environment.SettingsApiendpoint}/area-codes?${data}`;

        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }



    createAreaCode(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/area-codes`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateAreaCode(data: any, id: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/area-codes/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    deleteAreaCode(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/area-codes/${data}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    allAreaCode(): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/area-codes-all`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    AllAreaCodeByCityId(cityid: any) {
        const url = `${environment.SettingsApiendpoint}/area-codes-by-city-id/${cityid}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    // Change Area code status
    updateAreaStatus(id: any, status: any): Observable<any> {
        const data = {
            status
        };
        const url = `${environment.SettingsApiendpoint}/area-codes-change-status/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    // -----Import areacode
    uploadFile(data:any, imagefile: File) {
        const url = `${environment.SettingsApiendpoint}/areacode_import`;
        const formData = new FormData();
        formData.append('file', imagefile);
            formData.append('customer_id',data.customer_id);
            formData.append('provider_id',data.provider_id);

        return this.httpService
            .post(url, formData, this.httpService.headers)
            .pipe(catchError(this.Errorhandling));
    }

    // ---Export city
    downloadAreaCode() {
        const url = `${environment.SettingsApiendpoint}/areacode_export`;

        return this.httpService.get(url, this.httpService.headers);


    }

    //// ====================areacode all api end------------===================


    // =============================Pincode Api start===========================
    getPincodesForTable(search: any) {
        const url = `${environment.SettingsApiendpoint}/pincode?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    createPincode(data:any, imagefile: File) {
        const url = `${environment.SettingsApiendpoint}/pincode`;
        const formData = new FormData();

        formData.append('file', imagefile);

        formData.append('data', JSON.stringify(data));

        return this.httpService
            .post(url, formData, this.httpService.headers)
            .pipe(catchError(this.Errorhandling));
    }



    createRole(data: any) {
        const url = `${environment.SettingsApiendpoint}/addRole`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getRolById(id:any) {
        const url = `${environment.SettingsApiendpoint}/show/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updateRole(data: any, id:any) {
        const url = `${environment.SettingsApiendpoint}/editRole/${id}`;
        return this.httpService.put(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updatePincode(data: any, Id:any) {
        const url = `${environment.SettingsApiendpoint}/pincode`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    deletePincode(id: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/pincode/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    deleteRole(id: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/deleteRole/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    // Reschedule Reason Start
    rescheduleReasonList(data:any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/get-reschedule-reason?${data}`;
        return this.httpService.get(url,this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }
    createRescheduleReason(data: any) {
        const url = `${environment.OrderApiendpoint}/add-reschedule-reason`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updateRescheduleReason(data: any, id:any) {
        const url = `${environment.OrderApiendpoint}/edit-reschedule-reason/${id}`;
        return this.httpService.put(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    deleteRescheduleReason(id: any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/delete-reschedule-reason/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    // Reschedule Reason End
    // Cancel Reason Start
    cancelReasonList(data:any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/get-cancel-reason?${data}`;
        return this.httpService.get(url,this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }
    createCancelReason(data: any) {
        const url = `${environment.OrderApiendpoint}/add-cancel-reason`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updateCancelReason(data: any, id:any) {
        const url = `${environment.OrderApiendpoint}/edit-cancel-reason/${id}`;
        return this.httpService.put(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    deleteCancelReason(id: any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/delete-cancel-reason/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    // Cancel Reason End
       // pincode-export

       downloadPincode(): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/pincode-export`;
        return this.httpService.get(url,this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }

    roleList(data:any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/viewRole?${data}`;
        return this.httpService.get(url,this.httpService.headers)
            .pipe(catchError(this.Errorhandling))
    }

    // =============================Pincode Api end===========================

    // Master Dos Api
    getMasterDosForTable(search: any) {
        const url = `${environment.SettingsApiendpoint}/masterdos?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    createMasterDos(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/masterdos`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateMasterDos(data: any, id): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/masterdos/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    deleteMasterDos(id: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/masterdos/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    uploadMasterDos(imagefile: File) {
        const url = `${environment.SettingsApiendpoint}/masterdos-import`;
        const formData = new FormData();
        formData.append('file', imagefile);

        return this.httpService.post(url, formData, this.httpService.headers)
            .pipe(catchError(this.Errorhandling));
    }

    getSingleDropLocation(id: any) {
        const url = `${environment.SettingsApiendpoint}/drop-location/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    EditDroplocation(data: any,id:any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/drop-location/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    AddDroplocation(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/drop-location`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }


    // Email Setting
    getEmailSettings() {
        const url = `${environment.SettingsApiendpoint}/email-setting`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateEmailSettings(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/update-email-setting`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getAppSettings() {
        const url = `${environment.SettingsApiendpoint}/getPhleboSetting`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateAppSettings(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/addPhleboSetting`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getOrderSetting() {
        const url = `${environment.SettingsApiendpoint}/get-order-setting`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    updateOrderSetting(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/update-order-setting`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    saveSlots(data: any): Observable<any> {
        const url = `${environment.OrderApiendpoint}/save-slot`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    // Lab Start
    getLabList(data: any) {
        const url = `${environment.SettingsApiendpoint}/lab-list?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    createLab(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/add-lab`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updateLab(data: any,id: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/update-lab/${id}`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    deleteLab(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/delete-lab/${data}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updateLabStatus(id: any, status: any): Observable<any> {
        const data = {
            status
        };
        const url = `${environment.SettingsApiendpoint}/change-lab-status/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getAllMainLabs(city_id?: any) {
        let url = `${environment.SettingsApiendpoint}/all-lab-list/`;
        const cityIdStr = (city_id !== null && city_id !== undefined) ? String(city_id).trim() : '';

        if (cityIdStr !== '') {
            url += `?city_id=${cityIdStr}`;
        }
        // if (city_id && city_id.trim() !== '') {
        //     url += `?city_id=${city_id}`;
        // }
        return this.httpService
        .get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
    }
    //  updateLabStatus(id: any, status: any): Observable<any> {
    //     const url = `${environment.SettingsApiendpoint}/location/${id}/${status}`
    //     return this.httpService.get(url, this.httpService.headers)
    // }
    // updateLab(data: any, id: any): Observable<any> {
    //     const url = `${environment.SettingsApiendpoint}/add-lab/${id}`
    //     return this.httpService.put(url, data, this.httpService.headers)
    // }
    // Lab End

    // Device Start\
    getDeviceList(data: any) {
        const url = `${environment.SettingsApiendpoint}/device-list?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    createDevice(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/add-device`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updateDevice(data: any,id: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/update-device/${id}`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    deleteDevice(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/delete-device/${data}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updateDeviceStatus(id: any, status: any): Observable<any> {
        const data = {
            status
        };
        const url = `${environment.SettingsApiendpoint}/change-device-status/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getAllMainDevice() {
        let url = `${environment.SettingsApiendpoint}/all-device-list/`;
        return this.httpService
        .get(url, this.httpService.headers)
        .pipe(
            catchError(this.Errorhandling)
        );
    }

    bulkChangeStatus(formData: any) {
        const url = `${environment.SettingsApiendpoint}/change-multiple-device-status`;
        return this.httpService
        .patch(url, formData, this.httpService.headers)
        .pipe(catchError(this.Errorhandling));
    }

    // Device End


    // Device Inventory Start
    getDeviceInventoryList(data: any) {
        const url = `${environment.SettingsApiendpoint}/device-inventory-list?${data}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    createDeviceInventory(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/add-device-inventory`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updateDeviceInventory(data: any,id: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/update-device-inventory/${id}`;
        return this.httpService.post(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    deleteDeviceInventory(data: any): Observable<any> {
        const url = `${environment.SettingsApiendpoint}/delete-device-inventory/${data}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    updateDeviceInventoryPhlebo(id: any, phlebo_id: any): Observable<any> {
        const data = {
            phlebo_id
        };
        const url = `${environment.SettingsApiendpoint}/change-device-inventory-phlebo/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    assignPhleboMultipleDevices(formData: any, data: any) {
        const url = `${environment.SettingsApiendpoint}/assign_multiple_phlebo`;
        return this.httpService
        .put(url, formData, this.httpService.headers)
        .pipe(catchError(this.Errorhandling));
    }
    // Device Inventory End
    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
            console.error(err.error.message);
        } else {
            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }


}
